import React from 'react';

import {
  Paper,
  Stack,
  styled
} from '@mui/material';

import { activityTemplates } from 'modules/layer01';
import { TabBarContainer } from 'modules/layer00';



const HeaderStack = styled(Stack)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  flexDirection: 'row',
  justifyContent: 'flex-end',
  gap: theme.spacing(1)
}));



export interface IProps {
  elButtons: React.ReactNode | React.ReactNode[];
  elTabBar: React.ReactNode;
  elTabBarActions: React.ReactNode | React.ReactNode[];
  children: React.ReactNode | React.ReactNode;
}

export const FC: React.FC<IProps> = props => {
  return (
    <activityTemplates.AdminActivityTemplate.FC>
      <Paper sx={{ padding: '10px' }}>
        <HeaderStack>
          {props.elButtons}
        </HeaderStack>

        <TabBarContainer.FC
          tabBarComponent={props.elTabBar}
          otherComponents={props.elTabBarActions} />

        {props.children}
      </Paper>
    </activityTemplates.AdminActivityTemplate.FC>
  );
};
